import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ErpImportTransactionService from "services/common/ErpImportTransactionService";
import DaiHoiCoDongService from "services/crm/DaiHoiCoDongService";
import EmployeeService from "services/employee/EmployeeService";
import ThietLapLuongService from "services/salary/ThietLapLuongService";
import trainingProgramService from "services/Training/TrainingProgramService";

export const getAllImportTransactionByType = createAsyncThunk(
  "erpImportTransaction/getAllImportTransactionByType",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ErpImportTransactionService.getAllByType(data);
      return response.data;
    } catch (err) {
      console.error("API call failed:", err);
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const CommonImportTransaction = createAsyncThunk(
  "erpImportTransaction/CommonImportTransaction",
  async (data, { rejectWithValue }) => {
    const { onSuccess, formData } = data;
    try {
      const response = await ErpImportTransactionService.import(formData);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message || "Error");
    }
  }
);

export const getImportTaiSanByTransId = createAsyncThunk(
  "erpImportTransaction/getImportTaiSanByTransId",
  async (transId, { rejectWithValue }) => {
    try {
      const response = await ErpImportTransactionService.getImportTaiSanDetail(
        transId
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getImportBangLuongKhoanByTransId = createAsyncThunk(
  "erpImportTransaction/getImportBangLuongKhoanByTransId",
  async (transId, { rejectWithValue }) => {
    try {
      const response =
        await ThietLapLuongService.getImportBangLuongKhoanByTransId(transId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getImportBangLuongNhanVienByTransId = createAsyncThunk(
  "erpImportTransaction/getImportBangLuongNhanVienByTransId",
  async (transId, { rejectWithValue }) => {
    try {
      const response =
        await ThietLapLuongService.getImportBangLuongNhanVienByTransId(transId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetImportThongTinLuongNhanVienByTransId = createAsyncThunk(
  "erpImportTransaction/GetImportThongTinLuongNhanVienByTransId",
  async (transId, { rejectWithValue }) => {
    try {
      const response = await EmployeeService.importTLLuongEmployee(transId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetTrainingProgramCourseResultImportById = createAsyncThunk(
  "erpImportTransaction/GetTrainingProgramCourseResultImportById",
  async (transId, { rejectWithValue }) => {
    try {
      const response = await trainingProgramService.getImportById(transId);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const GetImportCoDongByTransIdApi = createAsyncThunk(
  "daiHoiCoDong/GetImportCoDongByTransIdApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DaiHoiCoDongService.importExcelByTransId(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);


const initialState = {
  loading: false,
  history: [],
  details: [],
};

const erpImportTransactionSlice = createSlice({
  name: "erpImportTransaction",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllImportTransactionByType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getAllImportTransactionByType.fulfilled,
      (state, action) => {
        state.loading = false;
        state.history = action.payload;
      }
    );
    builder.addCase(getAllImportTransactionByType.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getImportTaiSanByTransId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getImportTaiSanByTransId.fulfilled, (state, action) => {
      state.loading = false;
      state.details = action.payload;
    });
    builder.addCase(getImportTaiSanByTransId.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(CommonImportTransaction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(CommonImportTransaction.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(CommonImportTransaction.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getImportBangLuongKhoanByTransId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getImportBangLuongKhoanByTransId.fulfilled,
      (state, action) => {
        state.loading = false;
        state.details = action.payload;
      }
    );
    builder.addCase(getImportBangLuongKhoanByTransId.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getImportBangLuongNhanVienByTransId.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      getImportBangLuongNhanVienByTransId.fulfilled,
      (state, action) => {
        state.loading = false;
        state.details = action.payload;
      }
    );
    builder.addCase(getImportBangLuongNhanVienByTransId.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(
      GetImportThongTinLuongNhanVienByTransId.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      GetImportThongTinLuongNhanVienByTransId.fulfilled,
      (state, action) => {
        state.loading = false;
        state.details = action.payload;
      }
    );
    builder.addCase(
      GetImportThongTinLuongNhanVienByTransId.rejected,
      (state) => {
        state.loading = false;
      }
    );
    builder.addCase(
      GetTrainingProgramCourseResultImportById.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      GetTrainingProgramCourseResultImportById.fulfilled,
      (state, action) => {
        state.loading = false;
        state.details = action.payload;
      }
    );
    builder.addCase(
      GetTrainingProgramCourseResultImportById.rejected,
      (state) => {
        state.loading = false;
      }
    );
    builder.addCase(
      GetImportCoDongByTransIdApi.pending,
      (state) => {
        state.loading = true;
      }
    );
    builder.addCase(
      GetImportCoDongByTransIdApi.fulfilled,
      (state, action) => {
        state.loading = false;
        state.details = action.payload;
      }
    );
    builder.addCase(
      GetImportCoDongByTransIdApi.rejected,
      (state) => {
        state.loading = false;
      }
    );
  },
});

export const { setLoading } = erpImportTransactionSlice.actions;

export default erpImportTransactionSlice.reducer;
